(function(){
  // 1) Configuración de negocio
  const ENMARCABLES    = ['30CM','60CM','90CM','120CM','150CM']; // excluye '15 CM (sin marco)' [image:1]
  const FRAME_NO_REGEX = /SIN\s*MARCO/i;                          // detecta "Sin Marco (enrollado)" [image:1]

  // Usabilidad 15 CM (sin marco) → auto-seleccionar "Sin Marco"
  const SIZE_NO_FRAME  = '15 CM (sin marco)';     // etiqueta exacta del tamaño no enmarcable [image:1]
  const FRAME_NO_LABEL = 'Sin Marco (enrollado)'; // etiqueta exacta del valor de marco sin marco [image:1]

  // 2) Referencias de UI
  const root = document.querySelector('variant-radios, variant-selects'); // picker de variantes [attached_file:3]
  const productForm = document.querySelector('.product-form-main, form[action*="/cart/add"]'); // form ATC [attached_file:3]
  const frameSelectorWrapper = document.getElementById('frame-selector-wrapper'); // opcional [attached_file:3]
  const frameOverlay = document.getElementById('frame-overlay');                 // opcional [attached_file:3]
  const swatches = document.querySelectorAll('.frame-option-button');            // opcional [attached_file:3]

  // BLOQUE REAL DEL CHECKBOX (line item property)
  const fsPlexi = document.querySelector('.product__field--plexi'); // contenedor del checkbox [attached_file:3]
  if (fsPlexi) fsPlexi.classList.add('hidden'); // oculto de inicio [attached_file:3]

  if (!root || !productForm) return; // sin picker o form no seguimos [attached_file:3]

  // Localiza fieldsets por leyenda (TAMAÑO / MARCO)
  function findFieldsetByLegendText(container, legendStartsWith){
    const fsets = Array.from(container.querySelectorAll('.product-form__input, fieldset'));
    return fsets.find(fs => {
      const lg = fs.querySelector('legend');
      return lg && lg.textContent.trim().toUpperCase().startsWith(legendStartsWith);
    });
  }
  const fsSize  = findFieldsetByLegendText(root, 'TAMAÑO'); // p.ej. 150CM, 120CM, 90CM, 60CM, 30CM, 15 CM (sin marco) [image:1]
  const fsFrame = findFieldsetByLegendText(root, 'MARCO');  // p.ej. "Marco Madera Gris", "Sin Marco (enrollado)" [image:1]

  // Helpers
  function getSelectedValue(fs){
    if (!fs) return '';
    const r = fs.querySelector('input[type="radio"]:checked');
    if (r) return r.value;
    const s = fs.querySelector('select');
    return s ? s.value : '';
  }

  function resetPlexi(){
    if (!fsPlexi) return;
    const cb = fsPlexi.querySelector('#plexi_opt_in');
    if (cb && cb.checked){
      cb.checked = false;
      cb.dispatchEvent(new Event('change', {bubbles:true}));
    }
  }

  // NUEVO: auto-selección de "Sin Marco" cuando el tamaño es 15 CM (sin marco)
  function ensureNoFrameWhenNoFrameSize(){
    if (!fsSize || !fsFrame) return;

    const sizeCurrent = (getSelectedValue(fsSize) || '').toUpperCase();
    if (sizeCurrent === SIZE_NO_FRAME.toUpperCase()){
      // Radios
      const radio = Array.from(fsFrame.querySelectorAll('input[type="radio"]'))
        .find(r => r.value.trim().toUpperCase() === FRAME_NO_LABEL.toUpperCase());
      if (radio && !radio.checked){
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true })); // el tema recalcula variante y ATC [attached_file:3]
      }
      // Select (móvil)
      const select = fsFrame.querySelector('select');
      if (select && select.value.trim().toUpperCase() !== FRAME_NO_LABEL.toUpperCase()){
        const opt = Array.from(select.options)
          .find(o => o.value.trim().toUpperCase() === FRAME_NO_LABEL.toUpperCase());
        if (opt){
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true })); // actualiza variante y ATC [attached_file:3]
        }
      }
      // Fallback por si el botón sigue disabled
      const submitBtn = productForm.querySelector('.product-form__submit');
      if (submitBtn && submitBtn.hasAttribute('disabled')){
        setTimeout(()=> submitBtn.removeAttribute('disabled'), 50);
      }
    }
  }

  // 3) Regla: tamaño enmarcable Y marco distinto de "Sin Marco"
  function applyLogic(){
    // Asegura experiencia de 15 CM (sin marco)
    ensureNoFrameWhenNoFrameSize(); // ← llamada clave para el issue de usabilidad [image:1][attached_file:3]

    const size  = (getSelectedValue(fsSize)  || '').toUpperCase();
    const frame = (getSelectedValue(fsFrame) || '');
    const sizeOk   = ENMARCABLES.includes(size);             // true para 30/60/90/120/150 [image:1]
    const hayMarco = frame && !FRAME_NO_REGEX.test(frame);   // false si es "Sin Marco (enrollado)" [image:1]

    const showPlexi = sizeOk && hayMarco;

    // Mostrar/ocultar el checkbox + reset
    if (fsPlexi){
      fsPlexi.classList.toggle('hidden', !showPlexi);
      if (!showPlexi) resetPlexi();
    }

    // Opcional: selector visual de marco
    if (frameSelectorWrapper){
      frameSelectorWrapper.style.display = showPlexi ? 'block' : 'none';
      if (!showPlexi && frameOverlay) frameOverlay.removeAttribute('src');
      if (!showPlexi && swatches.length){
        swatches.forEach(s => s.classList.remove('active'));
        swatches[0].classList.add('active');
      }
    }
  }

  // 4) Swatches → actualiza overlay (opcional)
  if (swatches.length && frameOverlay){
    swatches.forEach(swatch=>{
      swatch.addEventListener('click', ()=>{
        const url = swatch.dataset.frameImage;
        if (url) frameOverlay.src = url;
        swatches.forEach(s => s.classList.remove('active'));
        swatch.classList.add('active');
      });
    });
  }

  // 5) Listeners y arranque
  function onChange(e){
    if (e.target.matches('input[type="radio"], select')) applyLogic();
  }
  root.addEventListener('change', onChange);        // cambios en picker [attached_file:3]
  productForm.addEventListener('change', onChange); // compatibilidad [attached_file:3]

  // Cubre ?variant= y renders dinámicos
  const obs = new MutationObserver(applyLogic);
  obs.observe(document.body, {subtree:true, childList:true}); // re-evaluar en cambios de DOM [attached_file:3]

  // Estado inicial
  applyLogic();
})();
